import React from "react";
import ContactHeader from "../../components/ContactHeader/ContactHeader";
import Footer from "../../components/Footer/Footer";
import Menu from "../../components/Menu/Menu";
import ContactHeroSection from "../../components/ContactHeroSection/ContactHeroSection";
import ContactFormSection from "../../components/ContactFormSection/ContactFormSection";
// import "./Contact.css";

const Contact = () => {
  return (
    <>
      <ContactHeader />
      <Menu />
      <main>
        <ContactHeroSection />
        <ContactFormSection />
      </main>
      <Footer />
    </>
  );
};

export default Contact;
